import { render, staticRenderFns } from "./DesmatamentoVega2025ComSoja2425VegaParaguai.vue?vue&type=template&id=4217e3f6&lang=pug"
import script from "./DesmatamentoVega2025ComSoja2425VegaParaguai.vue?vue&type=script&lang=js"
export * from "./DesmatamentoVega2025ComSoja2425VegaParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports